import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
import { Dealer } from 'src/app/models/dealer.model';
import { DealersService } from 'src/app/services/dealers.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-select-group-dialog',
  templateUrl: './select-group-dialog.component.html',
  styleUrls: ['./select-group-dialog.component.scss']
})
export class SelectGroupDialogComponent implements OnInit {

  isDealersLoading = false;
  dealers: Dealer[];
  currentOffset = 0;
  currentTake = 15;
  searchValue = '';
  userType = '';
  duns = '';

  dealerColumns: ColumnDefinition[] = [
    { columnDef: 'name', header: 'Name', cell: (w: any) => `${w.name}` },
    { columnDef: 'vendorId', header: 'BAC', cell: (w: any) => `${w.vendorId}` },
    { columnDef: 'zone', header: 'Zone', cell: (w: any) => `${w.zone}` },
    { columnDef: 'vendorCode', header: 'Vendor Code', cell: (w: any) => `${w.vendorCode}` }
  ];
  selection: SelectionModel<Dealer> = new SelectionModel(false);

  constructor(public dialogRef: MatDialogRef<SelectGroupDialogComponent>, private dealersService: DealersService, private router: Router, private userService : UserService) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onGoClick(): void {
    if (this.userType === 'dealeradmin') {
      this.dealersService.setViewAs(this.selection.selected[0]);
      this.router.navigate(['/admin/viewas', this.selection.selected[0].vendorId])
    }
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.userType = this.userService.user.businessFunction;
    if (this.userType === 'dealeradmin') {
      this.isDealersLoading = true;
      this.dealersService.search(this.currentOffset, this.currentTake, this.searchValue).subscribe(dealers => {
        this.dealers = dealers;
        this.isDealersLoading = false;
      });
    }
  }

  searchGroups() {
    this.isDealersLoading = true;
    this.dealersService.search(this.currentOffset, this.currentTake, this.searchValue).subscribe(dealers => {
      dealers.forEach(dealer => {
        this.selection.selected.forEach(selected => {
          if (dealer.guid == selected.guid) {
            this.selection.select(dealer);
            this.selection.deselect(selected);
          }
        })
      })
      this.dealers = dealers;
      this.isDealersLoading = false;
    })
  }

}
